import React from 'react';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import styled from "styled-components";
import { PageTitle } from '@shared/ui/atoms/PageTitle';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { CustomWhereaboutsList } from "../components/CustomWhereaboutsList";
import { DefaultWhereaboutsOptionsContentCard } from "../components/DefaultWhereaboutsOptionsContentCard";
import { WithCustomWhereaboutsUsageLimitChecker } from "../hooks/WithCustomWhereaboutsUsageLimitChecker";
import { useDispatch } from "react-redux";
import { redirectTo } from "@shared/store/auth.duck";
import { DialogIdentifiers, openDialogWithPayload } from "@shared/store/dialog.duck";
import { UsageTypeKey } from '@shared/dialogs/usage-limit-dialog/UsageLimitReachedDialog';
import { GoBackButton } from '@shared/ui/atoms/buttons/GoBackButton';
import { useTranslation } from "react-i18next";
import { DefaultWhereaboutsList } from "../components/DefaultWhereaboutsList";

export function CustomWhereaboutsListView(props: Props) {
  const dispatch = useDispatch();
  const limitReached = WithCustomWhereaboutsUsageLimitChecker();
  const {t} = useTranslation();

  const onAddClicked = () => {
    if (limitReached) {
      dispatch(openDialogWithPayload({
        payload: { usageType: UsageTypeKey.CustomWhereabouts },
        activeDialog: DialogIdentifiers.UsageLimitReachedDialog
      }))
    } else {
      dispatch(redirectTo('/manage/custom-whereabouts/add'))
    }
  }

  return (
    <Container>
      <GoBackButton url={"/manage"} />
      <PageTitle text={"whereabouts.custom-whereabouts"} headlineLarge={true} style={{margin: '0 0 12px 0'}} />
      <BodyRegular style={{marginBottom: 32}}>{t('custom-whereabouts-page.description')}</BodyRegular>

      <DefaultWhereaboutsList />
      <CustomWhereaboutsList />

      <PrimaryButton fullWidth={true}
                     text={'whereabouts.add-custom-whereabouts'}
                     style={{marginBottom: 24}}
                     click={onAddClicked} />

      <DefaultWhereaboutsOptionsContentCard />


    </Container>
  )
}

interface Props {
}

const Container = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
`
